import {NgModule} from '@angular/core';
import {HttpClientModule} from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';

import {ViewModule} from 'app/views/view.module';

import {RegDayComponent} from './reg_day/reg_day.component';
import {ActivityComponent} from "./activity/activity.component";
import {LiveComponent} from "./live/live.component";
import {UserChartsComponent} from "./user_charts/user_charts.component";
import { AclComponent } from './acl/acl.component';
import {UserService} from "./user.service";
import {ProviderFormComponent} from "./acl/provider_form.component";
import {RoleFormComponent} from "./acl/role_form.component";


@NgModule({
	imports: [
		ViewModule,
		HttpClientModule,
		ReactiveFormsModule,
	],
	declarations: [
		RegDayComponent,
		ActivityComponent,
		LiveComponent,
		UserChartsComponent,
		AclComponent,
		ProviderFormComponent,
		RoleFormComponent,
	],
	
	providers: [
		UserService,
	],
	exports: [
		UserChartsComponent,
	],
	entryComponents: [
		ProviderFormComponent,
		RoleFormComponent,
	],
})
export class UserModule { }
